import { FC, PropsWithChildren } from 'react'
import classNames from 'classnames'
import { getLozengeClassNames } from '@/atoms/Lozenge/Lozenge.utils'
import { useThemeContext } from '@/contexts/ThemeContext'

export type LozengeVariant = 'neutral' | 'outlined' | 'transparent' | 'brand' | 'guild'
export type LozengeSize = 'sm' | 'md' | 'lg'

interface Props extends PropsWithChildren {
  variant: LozengeVariant
  size?: LozengeSize
  className?: string
}
export const Lozenge: FC<Props> = ({ variant, size = 'md', className, children }) => {
  const { isDarkMode } = useThemeContext()

  return (
    <div className={classNames('lozenge', className, getLozengeClassNames(variant, size, isDarkMode))}>{children}</div>
  )
}
